export function EmptyBookingsIllustration({ width = 340, height = 240 }: { width?: number; height?: number }) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 340 240"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="text-camel-500"
    >
      <path
        d="M123 75.3062V192.306H54C47.3726 192.306 42 186.934 42 180.306V87.3062C42 80.6787 47.3726 75.3062 54 75.3062H123Z"
        fill="currentColor"
        fillOpacity="0.1"
      />
      <path
        d="M286 75.3062C292.627 75.3062 298 80.6787 298 87.3062V180.306C298 186.934 292.627 192.306 286 192.306H129V75.3062H286Z"
        fill="currentColor"
        fillOpacity="0.1"
      />
      <path
        d="M77.28 143.25L84 138.131L90.6 143.25L88.08 134.963L94.8 129.6H86.64L84 121.312L81.36 129.6H73.2L79.8 134.963L77.28 143.25ZM64.8 153C63.48 153 62.35 152.523 61.41 151.568C60.47 150.613 60 149.466 60 148.125V139.898C60 139.452 60.14 139.066 60.42 138.741C60.7 138.416 61.06 138.212 61.5 138.131C62.46 137.806 63.25 137.217 63.87 136.364C64.49 135.511 64.8 134.556 64.8 133.5C64.8 132.444 64.49 131.489 63.87 130.636C63.25 129.783 62.46 129.194 61.5 128.869C61.06 128.788 60.7 128.584 60.42 128.259C60.14 127.934 60 127.548 60 127.102V118.875C60 117.534 60.47 116.387 61.41 115.432C62.35 114.477 63.48 114 64.8 114H103.2C104.52 114 105.65 114.477 106.59 115.432C107.53 116.387 108 117.534 108 118.875V127.102C108 127.548 107.86 127.934 107.58 128.259C107.3 128.584 106.94 128.788 106.5 128.869C105.54 129.194 104.75 129.783 104.13 130.636C103.51 131.489 103.2 132.444 103.2 133.5C103.2 134.556 103.51 135.511 104.13 136.364C104.75 137.217 105.54 137.806 106.5 138.131C106.94 138.212 107.3 138.416 107.58 138.741C107.86 139.066 108 139.452 108 139.898V148.125C108 149.466 107.53 150.613 106.59 151.568C105.65 152.523 104.52 153 103.2 153H64.8ZM64.8 148.125H103.2V141.909C101.72 141.016 100.55 139.827 99.69 138.345C98.83 136.862 98.4 135.247 98.4 133.5C98.4 131.753 98.83 130.138 99.69 128.655C100.55 127.173 101.72 125.984 103.2 125.091V118.875H64.8V125.091C66.28 125.984 67.45 127.173 68.31 128.655C69.17 130.138 69.6 131.753 69.6 133.5C69.6 135.247 69.17 136.862 68.31 138.345C67.45 139.827 66.28 141.016 64.8 141.909V148.125Z"
        fill="currentColor"
      />
      <path
        d="M150 106C150 102.686 152.686 100 156 100H224C227.314 100 230 102.686 230 106C230 109.314 227.314 112 224 112H156C152.686 112 150 109.314 150 106Z"
        fill="currentColor"
        fillOpacity="0.1"
      />
      <path
        d="M196 162C196 158.686 198.686 156 202 156H270C273.314 156 276 158.686 276 162C276 165.314 273.314 168 270 168H202C198.686 168 196 165.314 196 162Z"
        fill="currentColor"
        fillOpacity="0.1"
      />
      <path
        d="M150 134C150 130.686 152.686 128 156 128H270C273.314 128 276 130.686 276 134C276 137.314 273.314 140 270 140H156C152.686 140 150 137.314 150 134Z"
        fill="currentColor"
        fillOpacity="0.1"
      />
      <path
        d="M249 106C249 102.686 251.686 100 255 100H270C273.314 100 276 102.686 276 106C276 109.314 273.314 112 270 112H255C251.686 112 249 109.314 249 106Z"
        fill="currentColor"
        fillOpacity="0.1"
      />
      <path
        d="M150 162C150 158.686 152.686 156 156 156H171C174.314 156 177 158.686 177 162C177 165.314 174.314 168 171 168H156C152.686 168 150 165.314 150 162Z"
        fill="currentColor"
        fillOpacity="0.1"
      />
      <path
        d="M63.1758 40.8975C64.8911 34.4959 71.4715 30.6968 77.873 32.4121L215.562 69.3057H55.5635L63.1758 40.8975Z"
        fill="currentColor"
        fillOpacity="0.1"
      />
    </svg>
  );
}
